import React, {Component} from 'react';
import PostList from '../post/PostList';
import { connect } from 'react-redux';
import { firestoreConnect } from 'react-redux-firebase';
import { compose } from 'redux';
import { Redirect } from 'react-router-dom';

class Dashboard extends Component {
    state = {
        showOnlyYourPost: false
    };

    handleChange = (e) => {
        this.setState({
			showOnlyYourPost: e.target.checked
		});
    }

    render() {
        const { posts, auth } = this.props;
        if(!auth.uid) return <Redirect to='/signin'/> 

        return (
            <div className="dashboard container">
                <div className="row">
                    <div className="col s12">
                        <h4>Dashboard</h4>

                        <p>
                            <label>
                                <input type="checkbox" id="onlyYourPosts" onChange={this.handleChange}/>
                                <span>Show only your posts</span>
                            </label>
                        </p>

                        <PostList posts={posts} auth={auth} showOnlyYourPost={this.state.showOnlyYourPost}/>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        posts: state.firestore.ordered.posts,
        auth: state.firebase.auth
    }
}

export default compose(
    connect(mapStateToProps),
    firestoreConnect([
        { collection: 'posts', orderBy: ['dateCreated', 'desc'] }
    ])
)(Dashboard)